import { useEffect, useState } from "react";
import CreateMobileNotificationInput from "../../../components/MobileNotification/CreateMobileNotification";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import { useParams } from "react-router-dom";

import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import {
  getNotificationById,
  getSailingData,
} from "../../../utils/ApiCalls/Mobile/Notification";

const CreateNotification = () => {
  const params = useParams();

  const [sailingData, setsailingData] = useState([]);
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Notifications",
      route: `/shore/notifications`,
    },
    {
      title: "Create New Notification",
      route: `/shore/notifications/add`,
    },
  ];

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    const fetchedSailingData = await getSailingData();

    if (sailingData.data?.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: fetchedSailingData.error, type: "error" },
      });

    setsailingData(fetchedSailingData.data);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  return (
    <Layout type={"create_per"} module_data={"Notifications"}>
      <CustomHeaderTitle title={"Create Notification"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Notification"}
      ></HeaderBread>
      <CreateMobileNotificationInput
        sailingData={sailingData}
        readOnly={false}
      />
    </Layout>
  );
};

export default CreateNotification;
